import EventEmitter from 'src/helpers/EventEmitter'
import EventObserver from 'src/helpers/EventObserver' 

class EventBus { 
  constructor() {
    Object.assign(this, EventEmitter)
    Object.assign(this, EventObserver) 
  }
}

export default new EventBus()